export function hydrateCompilers(cs, jq) {
  return cs.map(c => Object.assign({}, c, {
    jobQueue: jq.find(q => q.id === c.jobQueue?.id)
  }));
}
